import styled, { css } from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: var(--space-200);

  [role='rowgroup'] {
    margin-bottom: 0;
  }
`;
export const Cell = styled.div `
  color: var(--text-primary);
  min-height: 48px;
  padding: var(--space-100) 0;
  display: flex;
  align-items: center;
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-400);
    line-height: var(--font-line-height-400); /* 150% */
    letter-spacing: var(--font-letter-spacing-normal);
  }

  ${({ type }) => type === 'light' &&
    css `
      color: var(--text-secondary);
    `}

  ${({ type }) => type === 'strong' &&
    css `
      font-weight: var(--font-weight-medium);
    `}
`;
